import { render, staticRenderFns } from "./AlarmActionBlock.vue?vue&type=template&id=50c82d9a&scoped=true&"
import script from "./AlarmActionBlock.vue?vue&type=script&lang=js&"
export * from "./AlarmActionBlock.vue?vue&type=script&lang=js&"
import style0 from "./AlarmActionBlock.vue?vue&type=style&index=0&id=50c82d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c82d9a",
  null
  
)

export default component.exports